import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import FonctionTypeahead from '../../../../shared/components/Form/Field/FonctionTypeahead.jsx';
import ExpertiseTypeahead from '../../Form/Field/ExpertiseTypeahead.jsx';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import validate from './validate.js';

import './SkillsForm.scss';

export const name = 'GeneralPresForm';

class SkillsForm extends Component {
  static propTypes = {
    counter: PropTypes.number,
  };

  static defaultProps = {
    counter: 1300
  };

  constructor(props) {
    super(props);
    this.state = {
      counter: props.counter - (props.initialValues.freelance.summary ? props.initialValues.freelance.summary.length : 0),
    }
  }

  handleSummaryChange = (e) => {
    const _c = this.props.counter - e.target.value.length;
    this.setState({
      counter: _c < 0 ? 0 : _c,
    });
  }

  limiter = (value) => {
    if(value.length > this.props.counter) {
      return value.substring(0, this.props.counter);
    }

    return value
  }

  render() {
    return (
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <h4 className="text-center mt-5 mb-4">Compétences</h4>
          {this.props.isAdmin &&
            <div className="row">
              <div className="col-lg-6">
                <Field
                  label="Compétences - Mes spécialités (8 max)"
                  name="freelance.master_skills"
                  placeholder={this.props?.currentUniverse?.master_skills_placeholder ?? ''}
                  component={ExpertiseTypeahead}
                  customOnChange={() => this.props.submit()}
                />
              </div>
              <div className="col-lg-6">
                <Field
                  label="Compétences - Niveau Confirmé (10 max)"
                  name="freelance.expertises"
                  placeholder={this.props?.currentUniverse?.expertises_placeholder ?? ''}
                  component={ExpertiseTypeahead}
                  customOnChange={() => this.props.submit()}
                />
              </div>
            </div>
          }

          <h4 className="text-center mt-5 mb-4">Expertises</h4>
          <div className="row">
            <div className="col-lg-12">
              <Field
                label="Métiers/Fonctions exercées"
                name="freelance.fonctions"
                placeholder={this.props?.currentUniverse?.fonctions_placeholder ?? ''}
                component={FonctionTypeahead}
                customOnChange={() => this.props.submit()}
              />
            </div>
          </div>
          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit} contains={true}/>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    currentUniverse: state.universe.currentUniverse,
  })
)(reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(SkillsForm))
